import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { NavigationStore } from '@services/navigation.store';

export const authCanActivate: CanActivateFn = async (route, state): Promise<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const navigationStore = inject(NavigationStore);
  const router = inject(Router);

  await authService.ensureInitialized();

  if (!authService.isAuthenticated) {
    navigationStore.setBackUrl(state.url);
    return router.parseUrl('/login');
  }

  if (route.routeConfig?.path?.includes('registration') || route.routeConfig?.path?.includes('order-details')) {
    return true;
  }

  if (authService.isUserProfileIncomplete) {
    return router.parseUrl('/registration');
  }

  return true;
};
